<template>
    <v-dialog max-width="80vw" v-model="dialog">
        <v-btn class="btn" color="light-blue lighten-4 blue-grey--text text--darken-3" slot="activator">
            <span>Ajouter une liste</span>
            <v-icon right>add_shopping_cart</v-icon>
        </v-btn>
        <v-card>
            <v-card-title>
                <h2>Créez une liste</h2>
            </v-card-title>
            <v-card-text>
                <v-form class="px-3" ref="form">
                    <v-text-field label="Entrez le nom de la liste" v-model="nom" prepend-icon="playlist_add" :rules="Rules"></v-text-field>
                    <v-select
                        :items="typeListe"
                        v-model = "typeL"
                        menu-props="auto"
                        label="Type de liste"
                        hide-details
                        prepend-icon="list_alt"
                        single-line
                    ></v-select>
                    <v-btn class="mx-0 mt-4 btn_2" color="light-blue lighten-4 blue-grey--text text--darken-3" @click="submit" :loading="loading">
                        Valider
                        <span slot="loader" class="custom-loader">
                            <v-icon light>cached</v-icon>
                        </span>
                    </v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    prop: 'liste',
    data() {
        return {
            nom: '',
            Rules: [
                v => v.length <= 25 || '25 caractères maximum'
            ],
            dialog: false,
            typeListe: ['Courses', 'Todo List'],
            typeL: ''
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        }
    },
    methods: {
        submit() {
            if(this.$refs.form.validate()) {
                const uid = this.$store.getters.user.id;
                console.log(uid);
                const newListe = {
                    user: uid,
                    nom: this.nom,
                    typeL: this.typeL
                }
                this.$store.dispatch('ajListe', newListe);
                this.nom = '';
                this.typeL = '';
                this.dialog = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .btn {
        height: 70px;
        border-radius: 10px;

        &_2 {
            width: 100%;
            border-radius: 5px;
        }
    }

    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }

    @keyframes loader {
        from {
        transform: rotate(0);
        }
        to {
        transform: rotate(360deg);
        }
    }
</style>
